module.exports = __webpack_public_path__ + "img/reddit-logo.62412f9b.png";